var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message != null)?_c('div',{class:_vm.cssClass,attrs:{"role":"alert","aria-atomic":"true"}},[_vm._v(" "+_vm._s(_vm.message.Message)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }